import styled from 'styled-components'

import { AlignCenterItem, RowBetween } from '../../../components/common'
import { Text } from '../../../components/text'
import type { TextProps } from '../../../components/text'

import { ReactComponent as ChildrenIcon } from '../../../assets/ico/common/children.svg'

type Title =
  | string
  | { value: string; size?: TextProps['size']; weight?: TextProps['weight']; color?: TextProps['color'] }
type Content =
  | string
  | { value: string; size?: TextProps['size']; weight?: TextProps['weight']; color?: TextProps['color'] }

interface RowDataProps {
  title: Title
  content: Content
  isChildren?: boolean
}

export const RowData = ({ title, content, isChildren }: RowDataProps) => {
  const isStringTitle = typeof title === 'string'
  const isStringContent = typeof content === 'string'

  const titleProps: TextProps = {
    size: isStringTitle ? 16 : (title.size ?? 16),
    weight: isStringTitle ? 400 : (title.weight ?? 400),
    color: isStringTitle ? 'text_secondary' : (title.color ?? 'text_secondary'),
  }

  const contentProps: TextProps = {
    size: isStringContent ? 16 : (content.size ?? 16),
    weight: isStringContent ? 500 : (content.weight ?? 500),
    color: isStringContent ? undefined : (content.color ?? 'text_primary'),
  }

  return (
    <Container>
      <AlignCenterItem $gap={2}>
        {isChildren ? <ChildrenIcon /> : null}
        <Text {...titleProps}>{isStringTitle ? title : title.value}</Text>
      </AlignCenterItem>
      <Text $wordBreak="keep-all" {...contentProps}>
        {isStringContent ? content : content.value}
      </Text>
    </Container>
  )
}

const Container = styled(RowBetween)`
  gap: 8px;
  > * {
    &:first-child {
      flex-shrink: 0;
    }
    &:last-child {
      text-align: right;
    }
  }
`
